(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/frejaeid/same-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/frejaeid/same-device.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.frejaeid.SameDevice = Marionette.View.extend({
    template: function template(data) {
      return svs.player_login.templates.dummy(data);
    },
    behaviors: [{
      behaviorClass: svs.player_login.behaviors.FrejaEidErrorHandling
    }],
    isNativeApp: svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp') ? svs.core.config.data.svsconfig.isNativeApp : false,
    onAttach: function onAttach() {
      var _this = this;

      svs.player_login.radio.request('authRef').done(function (authRef) {
        _this.model.set('authRef', authRef);

        _this.model.set('startFrejaEid', true);

        svs.player_login.router.navigate("/frejaeidpoll?".concat(_this.model.toQueryString('frejaeid')), true);
      }).fail(function (err) {
        _this.triggerMethod('frejaEidError', err);
      });
    }
  });
})(Backbone, _, svs);
 })(window);